<mat-form-field fxFlex appearance="fill" floatLabel="never">
  <mat-label>{{ inputData["title"] }}</mat-label>
  <mat-select
    #thisSelect
    (openedChange)="openedChange($event)"
    placeholder="Select"
    [formControl]="selectFormControl"
    multiple
    disableRipple
  >
    <div class="select-container">
      <mat-optgroup>
        <mat-form-field style="width: 100%" floatLabel="auto">
          <input
            #search
            autocomplete="off"
            placeholder="Search"
            aria-label="Search"
            matInput
            [formControl]="searchTextBoxControl"
            (keyup)="handleInput($event)"
            (keydown)="handleInput($event)"
          />
          <button
            [disableRipple]="true"
            *ngIf="search.value"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearSearch($event)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </mat-optgroup>
      <mat-optgroup *ngIf="(filteredOptions | async).length == 0">
        <div>No results found!</div>
      </mat-optgroup>
      <mat-option
        (onSelectionChange)="selectionChange($event)"
        *ngFor="let option of filteredOptions | async"
        [value]="option"
      >
        {{ option.name }}
      </mat-option>
    </div>
  </mat-select>
</mat-form-field>

<!-- Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
